<template>
  <el-row
    type="flex"
    justify="center"
    align="middle"
    class="button"
    @click.native="$emit('click')"
  >
    <i v-if="type === 'add'" class="el-icon-plus"></i>
    <i v-if="type === 'upload'" class="button-upload"></i>
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  props: {
    type: String,
  },
};
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
  user-select: none;
  padding: 0 16px;
  min-width: 81px;
  height: 30px;
  line-height: 30px;
  border-radius: $border-radius;
  border: 1px dashed #409eff;
  @extend .f14;
  color: #409eff;
  text-align: center;
  i {
    margin-right: 6px;
  }
  &-upload {
    &::before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icon/upload.png") center/100% no-repeat;
      vertical-align: text-bottom;
    }
  }
}
</style>